import { createContext } from 'react';

export const ImpactQuestionContext = createContext<{
  panelOpen: boolean;
  setPanelOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  hideCompleted: boolean;
  setHideCompleted?: React.Dispatch<React.SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answersSelectorOverride?: any;
  // type not found
  // typeof selectImpactCo2Answers;
  // (state: RootState) => ImpactCo2Answer<unknown>[];
}>({
  panelOpen: false,
  hideCompleted: false,
  answersSelectorOverride: undefined,
});
